import React, { useState } from 'react';

import 'primeicons/primeicons.css';
import { useTranslation, withTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { QuoteFooterWrapper, QuoteHeaderWrapper } from './QuoteModel.style';

const QuoteModel = ({ t, showModel, onHide, onContinueBtn, onNewQuotation }) => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;

    return (
        <Modal
        show={showModel} 
        onHide={onHide} 
        aria-labelledby='ModalHeader'
        centered={true}>
            <QuoteHeaderWrapper>
                <Modal.Header closeButton className={`${currentLanguage === 'ar' && 'close-btn-ar'}`}>
                    <Modal.Title id='ModalHeader'>
                        <div className='title-section'>
                            <h5>{i18n.t('quotation_title1')}</h5>
                            <hr/>
                            <p>{i18n.t('quotation_title2')}</p>
                        </div>
                    </Modal.Title>
                </Modal.Header>
            </QuoteHeaderWrapper>
            
            <QuoteFooterWrapper>
                <Modal.Footer>
                    <button 
                    className='btn continue-btn'
                    onClick={() => {
                        if (onContinueBtn) onContinueBtn();
                        onHide();
                    }}
                    >
                        {i18n.t('quotation_continue_btn')}
                    </button>
                    <button 
                    className='btn new-quotation-btn'
                    onClick={() => {
                        if (onNewQuotation) onNewQuotation();
                        onHide();
                    }}>
                        {i18n.t('quotation_new_btn')}
                    </button>
                </Modal.Footer>
            </QuoteFooterWrapper>
            
        </Modal>    
    )
}

export default withTranslation()(QuoteModel);
